<template>
  <div id="new_user" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <!-- <div class="title">
            <h2>登録情報入力</h2>
            <p>下記フォームより入力してください。</p>
          </div> -->
          <dd-user-input
            ref="userInputRef"
            :isEdit="true"
            :isPrivateUser="isPrivateUser"
            :userForm="userForm"
          />
          <div class="control_btn_area">
            <button class="betail_btn6" @click="update()">更新する</button>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
// import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
// import {CORP_TYPE, INFO_SRC} from '../constants/TypeEc'

// Module
import Header from '../components/common/DcHeader'
import DcUserInfo from '../components/user/DcUserInfo'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-user-input': DcUserInfo,
    'dd-sitemap': DcSiteMap
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'dcUserInfo',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'userInfo', key: 'dcUserInfo', title: '会員情報更新'}
      ],
      userForm: {
        corpType: '',
        corpName: '',
        corpBranchName: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        infosrc: '',
        recvInfo: false,
        consent: false
      },
      isEdit: false,
      errors: {},
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        email: ''
      }
    }
  },
  computed: {
    isPrivateUser: function () {
      if (!this.userForm) return false
      if (this.userForm.userLevel === 3) {
        return true
      }
      return false
    }
  },
  methods: {
    update: function () {
      let ret = this.$refs.userInputRef.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        corpType: this.userForm.corpType,
        corpName: this.userForm.corpName,
        corpBranchName: this.userForm.corpBranchName,
        corpDept: this.userForm.corpDept,
        userLastName: this.userForm.userLastName,
        userFirstName: this.userForm.userFirstName,
        userLastNameKana: this.userForm.userLastNameKana,
        userFirstNameKana: this.userForm.userFirstNameKana,
        tel: this.userForm.tel,
        fax: this.userForm.fax,
        postcd: this.userForm.postcd,
        state: this.userForm.state,
        city: this.userForm.city,
        street: this.userForm.street,
        infosrc: this.userForm.infosrc,
        inviteCode: this.userForm.inviteCode,
        recvInfo: this.userForm.recvInfo
      }
      axios.post(DC_URL.USER + '/update-user', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.fieldErrorMessages.email = response.data.errorMessage
          this.$refs.userInputRef.setErrorMessage(this.fieldErrorMessages)
        } else {
          // 更新データをストレージに格納する
          App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
          this.$router.go(-1)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    fetchData: function () {
      this.userForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcUpdateUserInput.vue